export const SET_SELECTED_PERIOD = "SET_SELECTED_PERIOD";
export const SET_START_DATE = "SET_START_DATE";
export const SET_END_DATE = "SET_END_DATE";